package io.horion.cv.viewModel

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import io.horion.cv.api.datasource.common.Generate
import io.horion.cv.api.datasource.cv.OrionCV
import io.horion.cv.api.usecase.CvUseCase
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch

class DashboardViewModel(
    private val cvUseCase: CvUseCase,
    private val scope: CoroutineScope = CoroutineScope(Dispatchers.Main)
) {

    var cvList by mutableStateOf<List<Generate>>(emptyList())
        private set

    var letterList by mutableStateOf<List<Generate>>(emptyList())
        private set

    var isLoading by mutableStateOf(false)
        private set

    fun loadCvHistory(refresh: Boolean = false) {

        scope.launch {
            isLoading = true
            val result = cvUseCase.getCvHistory(refresh)
            cvList = result ?: emptyList()
            isLoading = false
        }
    }

    fun loadLetterHistory(refresh: Boolean = false) {
        scope.launch {
            isLoading = true
            val result = cvUseCase.getLetterHistory(refresh)
            letterList = result ?: emptyList()
            isLoading = false
        }
    }

    fun deleteCv(cvId: String) {
        scope.launch {
            val result = cvUseCase.deleteCv(cvId)
            if (result?.success == true) {
                cvList = cvList.filter { it.id != cvId }
            }
        }
    }

    fun deleteLetter(letterId: String) {
        scope.launch {
            val result = cvUseCase.deleteLetter(letterId)
            if (result?.success == true) {
                letterList = letterList.filter { it.id != letterId }
            }
        }
    }

    fun downloadCv(url: String) {
        window.open(url, "_blank")
    }

    suspend fun loadAndGetCvList(): List<OrionCV>? {
        return cvUseCase.getCvList()
    }
}
